export const SET_COMPANY = 'SET_COMPANY';

export const setCompany = name => ({
  type: SET_COMPANY,
  payload: {
    name,
  },
});



// WEBPACK FOOTER //
// ./src/store/company/actions.js